'use client';

import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
import { Image } from '@coolblue-development/next-image/client';
import { useTranslation } from '@i18n/useTranslation';
import React from 'react';

export const SpotlerSuccessMessage = () => {
  const { t } = useTranslation('vacancyDetail.applicationForm.spotlerSuccessMessage');

  return (
    <Flex direction={{ xs: 'column', md: 'row' }} gap={{ xs: 400, md: 600 }} alignItems='center'>
      <Flex direction='column' gap={400} sx={{ flex: 1 }}>
        <Flex direction='column' gap={200}>
          <Typography variant='h2' mb={0}>
            {t('title')}
          </Typography>
          <Typography variant='intro'>{t('sendingWhatsAppMessage')}</Typography>
        </Flex>
        <Flex direction='column' gap={200}>
          <Typography variant='h3' mb={0}>
            {t('whatToExpect')}
          </Typography>
          <Typography mb={0}>
            {t('youGetAMessage')}
            <br />
            {t('noMessageReceived')}
          </Typography>
        </Flex>
        <Flex direction='column' gap={200}>
          <Typography variant='h3' mb={0}>
            {t('answerTheQuestions')}
          </Typography>
          <Typography mb={0}>{t('timeToRespond')}</Typography>
        </Flex>
      </Flex>
      <Image
        imageId='482673569'
        alt=''
        width={520}
        height={395}
        loading='lazy'
        fileCollection='content'
        objectFit='cover'
        sx={{
          flex: 1,
          borderRadius: freddyTheme.borderRadius[100],
          minWidth: '411px',
          [freddyTheme.breakpoint.maxWidth('lg')]: {
            width: '100%',
            maxHeight: '312px'
          },
          [freddyTheme.breakpoint.maxWidth('md')]: {
            minWidth: 'unset',
            width: '100%',
            maxHeight: '261px'
          }
        }}
      />
    </Flex>
  );
};
